import Analytics, { useAnalytics } from './Analytics'

export { useAnalytics }

export default Analytics
